import {FC} from 'react'
import Button from 'app/components/Button'

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>

const ExportButton: FC<Props> = ({className, onClick, ...rest}) => {
  return (
    <Button className={`${className}`} onClick={onClick} {...rest}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
        className='icon icon-tabler icons-tabler-outline icon-tabler-download me-2'
      >
        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
        <path d='M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2' />
        <path d='M7 11l5 5l5 -5' />
        <path d='M12 4l0 12' />
      </svg>
      Export
    </Button>
  )
}

export default ExportButton
